import React, { useEffect, useState } from "react";
import { auth } from "../firebase";
import { getMyImpactNetworks } from "../services/impactNetworks";

export default function ImpactNetworkAttributionSelector({
  selectedNetworkId,
  onChange,
}) {
  const user = auth.currentUser;
  const [networks, setNetworks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadNetworks() {
      if (!user?.uid) {
        setLoading(false);
        return;
      }

      const data = await getMyImpactNetworks(user.uid);
      setNetworks(data);
      setLoading(false);
    }

    loadNetworks();
  }, [user?.uid]);

  const handleChange = (e) => {
    const value = e.target.value;

    if (!value) {
      onChange({
        networkId: null,
        networkName: null,
      });
      return;
    }

    const selected = networks.find((n) => (n.networkId || n.id) === value);

    onChange({
  networkId: selected?.networkId || selected?.id || null,
  networkName: selected?.name || null,
});
  };

  if (loading) return null;

  if (networks.length === 0) {
    return null;
  }

  return (
    <div className="section-card">
      <h3>Impact Network Attribution</h3>
      <p>
        Choose whether this commitment should count toward one of your Impact
        Networks. This does not change who pays — it only affects impact
        reporting.
      </p>

      <select
        value={selectedNetworkId || ""}
        onChange={handleChange}
        className="network-select"
      >
        <option value="">Personal Giving</option>

        {networks.map((network) => (
          <option key={network.networkId || network.id} value={network.networkId || network.id}>
  {network.name}
</option>
        ))}
      </select>
    </div>
  );
}